module.exports = __webpack_public_path__ + "static/media/glass_door_5d.9ff38ba5.jpg";